<template lang="html">
    <div class="account-types">
        <ModalForm :showModal="showAddModal" :action="Insurance.setup.action">
            <template>
                <CustomForm 
                    :pages="Insurance.setup.pages" 
                    :action="Insurance.setup.action" 
                    :buttonText="Insurance.setup.actionBtn" 
                    showTitle="false">
                </CustomForm>
            </template>
        </ModalForm>

        <ModalForm v-if="Insurance && Insurance.wizard && Insurance.wizard.upload_underwritters" :showModal="showUploadUnderwritters" :action="Insurance.wizard.upload_underwritters.action">
            <template>
                <div class="custom-file">
                    <input type="file" class="custom-file-input" id="fileSelector" name="files[]" @change="onFileSelected" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel">
                    <label class="custom-file-label" for="customFile">Upload File</label>
                </div>
                <figure class="pos-relative col-md-4" v-if="showImage">
                    <p>{{form.placeholder}}</p>            
                </figure>

                <button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5" @click="saveUnderwriterUpload()">
                    <i data-feather="file" class="wd-10 mg-r-5"></i> Save Upload
                </button>
            </template>
        </ModalForm>
        
        <div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
            <div>
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb breadcrumb-style1 mg-b-10">
                        <li class="breadcrumb-item">
                            <router-link :to="{name: 'Dashboard'}">
                                Admin
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">Insurance List</li>
                    </ol>
                </nav>
                <h4 class="mg-b-0 tx-spacing--1">Pending Underwritters</h4>
            </div>
            <div class="d-none d-md-block">
                <button class="btn btn-sm pd-x-15 btn-white btn-uppercase mg-l-5" @click="addUnderwritter()">
                    <i data-feather="printer" class="wd-10 mg-r-5"></i> Add Underwritter
                </button>
                <button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5" @click="uploadUnderwritters()">
                    <i data-feather="file" class="wd-10 mg-r-5"></i> Upload Underwritters
                </button>
            </div>
        </div>

        <div class="row row-xs">
            <div class="col-lg-12 col-xl-12 mg-t-10">
                <CustomTable 
                    :icon="Insurance.table.icon"
                    :title="Insurance.table.title"
                    :subtitle="Insurance.table.subtitle"
                    :tableFields="Insurance.table.table_fields" 
                    :tableData="underwritters" 
                    :searchFields="Insurance.table.searchFields"
                    :rowData="Insurance.table.rowData">
                </CustomTable>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    created() {
        console.log('created: Initializing Insurance model');
        this.Insurance = Models.Insurance;
        console.log('created: Insurance model loaded', this.Insurance);
        console.log('created: Checking Insurance.wizard', this.Insurance.wizard);
        console.log('created: Checking Insurance.wizard.upload_underwritters', this.Insurance.wizard?.upload_underwritters);

        Event.$on('modal:close', async (payload) => {
            console.log('modal:close event triggered with payload', payload);
            if(payload.action === 'insurance') {
                this.showAddModal = false;
                console.log('modal:close - Closed insurance modal');
            }
            if(payload.action === 'upload_underwritters') {
                this.showUploadUnderwritters = false;
                console.log('modal:close - Closed upload_underwritters modal');
            }
        });

        Event.$on('form:submit', async (payload) => {
            console.log('form:submit event payload', JSON.stringify(payload, null, 2));
            if(payload.action === this.Insurance.setup.action) {
                console.log('Checking category value:', payload.formData.category);
                await this.saveUnderwritter(payload.formData);
            }
        });

        Event.$on('underwritter:view', (payload) => {
            console.log('underwritter:view event triggered with payload', payload);
            this.$router.push({name: 'Entities-Underwritters-ViewUnderwritter', params: {id: payload.licence_number}});
        });
    },
    data() {
        console.log('data: Initializing component data');
        return {
            Insurance: {},
            underwritters: [],
            showAddModal: false,
            showUploadUnderwritters: false,
            file: '',
            showImage: false,
            form: {
                placeholder: '',
                model: '',
                url: ''
            },
        };
    },
    methods: {
        async saveUnderwriterUpload() {
            console.log('saveUnderwriterUpload: Starting upload process');
            try {
                Event.$emit("loader:show", true);
                console.log('saveUnderwriterUpload: Uploading file', this.file);
                await this.uploadDoc();
                console.log('saveUnderwriterUpload: File uploaded, fetching underwriters');
                await this.getUnderwritters();
                this.showUploadUnderwritters = false;
                Event.$emit("loader:show", false);
                console.log('saveUnderwriterUpload: Upload successful');
                notification.notify('success', 'Underwritters Uploaded', `Underwritters have been successfully uploaded`);
            } catch (err) {
                console.error('saveUnderwriterUpload: Error during upload', err);
                notification.notify('error', 'Underwritter Upload Error', `The upload was unsuccessfully Kindly retry later`);
                Event.$emit("loader:show", false);
            }
        },
        uploadDoc() {
            console.log('uploadDoc: Preparing to upload file', this.file);
            return new Promise(async (resolve, reject) => {
                try {
                    var formDataToUpload = new FormData();
                    formDataToUpload.append("file", this.file);   
                    formDataToUpload.append("file_type", "underwriter_upload");                                    
                    console.log('uploadDoc: Sending multipart request to /api/upload/v1/admin/underwriter');
                    let respData = await req.callServerMultipart('/api/upload/v1/admin/underwriter', formDataToUpload);
                    console.log('uploadDoc: Upload response', respData);
                    return resolve(respData);
                } catch (err) {
                    console.error('uploadDoc: Error during multipart upload', err);
                    return reject(err);
                }
            });
        },
        onFileSelected(event) {
            console.log('onFileSelected: File selected', event.target.files);
            Array.from(event.target.files).forEach(file => {
                this.file = file;
                this.form.url = URL.createObjectURL(file);
                this.form.placeholder = file.name;
                this.showImage = true;  
                console.log('onFileSelected: File processed', this.form);
            });
        },
        getUnderwritters() {
    console.log('getUnderwritters: Fetching underwriters list');
    return new Promise(async (resolve, reject) => {
        try {
            let res = await req.callServerSecureV2({
                service: {
                    name: "underwriting",
                    version: "v1"
                },
                resource: {
                    name: "underwriter",
                    version: "v1"
                },
                action: {
                    name: "listUnderwriters",
                    version: "v1"
                },
                data: {}
            });

            console.log('getUnderwritters: Response received', res.data);

            // ✅ Map the API response to match table config
            this.underwritters = res.data.result.data.map(u => ({
                licence_number: u.licenceNumber,  // matches insurance.model.js
                name: u.name,
                category: u.category,
                emails: Array.isArray(u.emails) ? u.emails.join(", ") : u.emails,
                classes: Array.isArray(u.classes) ? u.classes.join(", ") : u.classes,
                contacts: Array.isArray(u.contacts) ? u.contacts.join(", ") : u.contacts
            }));

            console.log('getUnderwritters: Underwriters mapped for table', this.underwritters);
            resolve(true);

        } catch (err) {
            console.error('getUnderwritters: Error fetching underwriters', err);
            reject(err);
        }
    });
},
        addUnderwritter() {
            console.log('addUnderwritter: Opening add underwriter modal');
            this.showAddModal = true;
        },
        uploadUnderwritters() {
            console.log('uploadUnderwritters: Opening upload underwriters modal');
            this.showUploadUnderwritters = true;
        },
       saveUnderwritter(formData) {
            console.log('saveUnderwritter: Saving underwriter with formData', formData);
            return new Promise(async (resolve, reject) => {
                try {
                    // Ensure category is included; log if missing
                    if (!formData.category) {
                        console.error('saveUnderwritter: Category is missing or undefined');
                        notification.notify('error', 'Validation Error', 'Category is required');
                        Event.$emit('form:action-error', {action: this.Insurance.setup.action});
                        return reject(new Error('Category is required'));
                    }

                    let res = await req.callServerSecureV2({
                        service: {
                            name: "underwriting",
                            version: "v1"
                        },
                        resource: {
                            name: "underwriter",
                            version: "v1"
                        },
                        action: {
                            name: "createUnderwriter",
                            version: "v1"
                        },
                        data: {
                            licence_number: formData.licence_number,
                            name: formData.name,
                            category: formData.category,
                            emails: formData.emails ? formData.emails.split(',').map(e => e.trim()) : [],
                            classes: formData.classes ? formData.classes.split(',').map(c => c.trim()) : [],
                            contacts: formData.contacts ? formData.contacts.split(',').map(con => con.trim()) : []
                        }
                    });
                    console.log('saveUnderwritter: Underwriter created', res.data);
                    notification.notify('success', 'Underwritter Created', `${formData.name} has been successfully saved`);
                    await this.getUnderwritters();
                    Event.$emit('form:action-complete', {action: this.Insurance.setup.action, clear: true});
                    this.showAddModal = false;
                    console.log('saveUnderwritter: Form action completed and modal closed');
                    resolve(true);
                } catch (err) {
                    console.error('saveUnderwritter: Error creating underwriter', err);
                    Event.$emit('form:action-error', {action: this.Insurance.setup.action});
                    reject(err);
                }
            });
        }
    },
    async mounted() {
        Event.$emit("loader:show", false);
        console.log('mounted: Component mounted, fetching underwriters');
        await this.getUnderwritters();
        
        console.log('mounted: Underwriters fetched and loader hidden');
    }
};
</script>

<style lang="less">
.account-types row row-xs {
}
</style>